import { InjectionToken } from '@angular/core';

export const PLATFORM_CONFIG = new InjectionToken<any>('PLATFORM_APP_CONFIG');
